// ChecklistPage.js
// Customer details collect பண்ற page
// GST வேணுமா வேண்டாமா choose பண்ணலாம்
// Invoice number auto generate ஆகும்

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function ChecklistPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // localStorage-லிருந்து existing checklist data load
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem('invoice_checklist');
    if (saved) {
      try { return JSON.parse(saved); }
      catch { }
    }
    return {
      invoice_number: '',
      invoice_date: new Date().toISOString().split('T')[0],
      customer_name: '',
      customer_address: '',
      customer_phone: '',
      has_gst: false,
      customer_gst: ''
    };
  });

  // Auto-generate invoice number on load
  // useEffect(() => {
  //   if (!formData.invoice_number) {
  //     fetchInvoiceNumber();
  //   }
  // }, []);

  // // Save to localStorage whenever form changes
  // useEffect(() => {
  //   localStorage.setItem('invoice_checklist', JSON.stringify(formData));
  // }, [formData]);

  // Auto-generate invoice number
useEffect(() => {
  if (!formData.invoice_number) {
    fetchInvoiceNumber();
  }
}, [formData.invoice_number]);

// Save to localStorage
useEffect(() => {
  localStorage.setItem('invoice_checklist', JSON.stringify(formData));
}, [formData]);

  const fetchInvoiceNumber = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/invoice-number`);
      setFormData(prev => ({ ...prev, invoice_number: res.data.invoice_number }));
    } catch {
      // Backend இல்லன்னா manual generate பண்றோம்
      const d = new Date();
      const yr = d.getFullYear().toString().slice(-2);
      const nextYr = (parseInt(yr) + 1).toString().padStart(2, '0');
      const num = Math.floor(Math.random() * 900) + 100;
      setFormData(prev => ({
        ...prev,
        invoice_number: `${yr}-${nextYr}/AF/${num}`
      }));
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // const handleSubmit = async () => {
  //   if (!formData.customer_name.trim()) {
  //     alert('Customer Name கொடுக்கணும்!');
  //     return;
  //   }

  //   setLoading(true);   // ✅ ADD THIS

  //   setTimeout(() => {
  //     navigate('/invoice');
  //     setLoading(false);  // ✅ ADD THIS
  //   }, 500);
  // };

  const handleSubmit = async () => {
  if (!formData.customer_name.trim()) {
    alert('Customer Name கொடுக்கணும்!');
    return;
  }

  if (!formData.customer_address.trim()) {
    alert('Customer Address கொடுக்கணும்!');
    return;
  }

  setLoading(true);

  try {
    // Save to localStorage
    localStorage.setItem('invoice_checklist', JSON.stringify(formData));
    
    // ✅ Navigate to invoice page
    navigate('/invoice');
  } catch (error) {
    console.error('Error saving checklist:', error);
    alert('Failed to save customer details');
  } finally {
    setLoading(false);
  }
};

  const handleBack = () => {
    navigate('/');
  };

  return (

    <div>
      {/* Header */}
      <div className="header">
        <div className="header-title">
          <h1>AKSHAYA Wood Furniture & Interiors</h1>
        </div>
      </div>

      <div className="container">
        <div className="card">
          <div className="section-title">✅ Customer Details & Invoice Info</div>

          {/* Invoice Number & Date */}
          <div className="form-row" style={{ marginBottom: '18px' }}>
            <div className="form-group">
              <label>Estimate Number *</label>
              <input
                type="text"
                value={formData.invoice_number}
                onChange={e => handleChange('invoice_number', e.target.value)}
                placeholder="Auto generate ஆகும்..."
              />
            </div>
            <div className="form-group">
              <label>Estimate Date *</label>
              <input
                type="date"
                value={formData.invoice_date}
                onChange={e => handleChange('invoice_date', e.target.value)}
              />
            </div>
          </div>

          {/* Customer Name */}
          <div className="form-group">
            <label>Customer Name *</label>
            <input
              type="text"
              value={formData.customer_name}
              onChange={e => handleChange('customer_name', e.target.value)}
              placeholder="Customer பேரு..."
            />
          </div>

          {/* Customer Address */}
          <div className="form-group">
            <label>Customer Address *</label>
            <textarea
              rows={3}
              value={formData.customer_address}
              onChange={e => handleChange('customer_address', e.target.value)}
              placeholder="வீட்டு முகவரி..."
              style={{
                width: '100%',
                padding: '10px',
                border: '1.5px solid #ddd',
                borderRadius: '8px',
                fontSize: '14px',
                resize: 'vertical'
              }}
            />
          </div>

          {/* Phone */}
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              value={formData.customer_phone}
              onChange={e => handleChange('customer_phone', e.target.value)}
              placeholder="9XXXXXXXXX"
            />
          </div>

          {/* GST Toggle */}
          <div
            className="toggle-gst"
            onClick={() => handleChange('has_gst', !formData.has_gst)}
            style={{
              border: formData.has_gst ? '2px solid #ff6b00' : '2px solid #ddd',
              background: formData.has_gst ? '#fff8f3' : '#f9f9f9'
            }}
          >
            <input
              type="checkbox"
              checked={formData.has_gst}
              onChange={e => handleChange('has_gst', e.target.checked)}
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
            <span style={{ fontWeight: '600', fontSize: '15px' }}>
              இந்த Customer-க்கு GST Invoice வேணுமா? (18% applicable)
            </span>
          </div>

          {/* GST Number - only if GST selected */}
          {formData.has_gst && (
            <div className="form-group" style={{
              padding: '15px',
              background: '#fff8f3',
              borderRadius: '8px',
              border: '1px solid #ffccaa'
            }}>
              <label>Customer GST Number *</label>
              <input
                type="text"
                value={formData.customer_gst}
                onChange={e => handleChange('customer_gst', e.target.value.toUpperCase())}
                placeholder="33XXXXX0000X0ZX"
                maxLength={15}
                style={{ letterSpacing: '2px', fontWeight: '600' }}
              />
              <p style={{ fontSize: '12px', color: '#888', marginTop: '5px' }}>
                * GST இருந்தா SGST 9% + CGST 9% = 18% add ஆகும்
              </p>
            </div>
          )}

          {/* Buttons */}
          <div className="btn-group" style={{ marginTop: '25px' }}>
            <button className="btn btn-secondary" onClick={handleBack}>
              ← Back
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Generate Invoice →'}

            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChecklistPage;